var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 536.682,
    height: 279.558,
    viewBox: "0 0 536.682 279.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(0 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(197.148 160.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(49.722 97.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M289.2,357.873c1.456.61,3.251-.3,4.077-2.071l27.372-58.6-9.566-4.015-23.245,60.277C287.125,355.309,287.727,357.256,289.2,357.873Z",
    transform: "translate(-287.537 -293.192)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(74.978 97.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M348.238,357.719c1.452-.622,2.044-2.545,1.346-4.371l-23.1-60.408-9.535,4.086,27.172,58.61C344.955,357.426,346.773,358.347,348.238,357.719Z",
    transform: "translate(-316.953 -292.94)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(47.184 31.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M330.059,216.242s29.156,7.392,25.19,42.058c-3.642,31.841-32.991,42.365-54.847,34.872s-14.7-29.47-14.7-29.47Z",
    transform: "translate(-284.581 -216.242)",
    fill: "#e2dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(62.655 85.037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 17.179,
    cy: 3.867,
    rx: 17.179,
    ry: 3.867,
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(63.353 128.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M318.674,330.88l.676,12.813-14.763,3.639-1.174-5.227.081-13.066Z",
    transform: "translate(-303.414 -329.04)",
    fill: "#db786e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(25.044 126.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M274.8,329.265l-.22,12.829-14.981,2.6-.806-5.3.994-13.028Z",
    transform: "translate(-258.794 -326.369)",
    fill: "#db786e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(18.34 64.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M293.009,254.876s-30.093,11.112-34.37,16.753c-3.7,4.884-8.43,52.211-7.544,53.1s27.2,1.207,28.343.434,6.693-35.6,8.3-35.693S320.2,258.7,320.2,258.7Z",
    transform: "translate(-250.986 -254.876)",
    fill: "#507849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(47.884 68.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M326.572,259.041s1.207,12.015.281,16.509-10.419,9.149-10.419,9.149,5.952,39.75,5.32,40.031-26.687,1.217-27.2.937-11.092-46.719-8.842-53.553,9.666-7.841,9.666-7.841Z",
    transform: "translate(-285.397 -259.041)",
    fill: "#507849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(76.656 84.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M320.823,287.53a.266.266,0,0,1-.253-.186c-.254-.8-2.448-7.916-1.362-9.751a.94.94,0,0,1,.635-.477.809.809,0,0,1,.723.207c1.428,1.308.617,9.087.52,9.971a.266.266,0,0,1-.238.234Zm-.81-9.9a.289.289,0,0,0-.065.008.408.408,0,0,0-.283.224c-.683,1.156.294,5.411,1.024,8.016.274-3.275.332-7.417-.482-8.163A.277.277,0,0,0,320.013,277.631Z",
    transform: "translate(-318.908 -277.1)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(0 136.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M274.059,357.479s-.45-20.278-3.6-19.855-6.3,3.379-6.3,3.379-7.2-3.8-10.353-1.69-4.962,6.76-4.962,6.76l-14.593,7.67a8.557,8.557,0,0,0-4.617,7.2,4.565,4.565,0,0,0,.155,1.6c.477,1.318,27.162.579,38.867.191a5.425,5.425,0,0,0,5.406-5.26Z",
    transform: "translate(-229.624 -337.617)",
    fill: "#f2513b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(49.431 137.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M293.633,352.2s4.131-10.872,6.924-12.8,10.044,3.793,10.044,3.793,5.794-6.411,7.338-3.161,2.547,15,1.5,17.623-9.1,7.152-19.82,7.389c-5.052.112-12.376-1.268-12.423-3C287.123,359.313,291.955,354.044,293.633,352.2Z",
    transform: "translate(-287.198 -339.005)",
    fill: "#f2513b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(47.346 70.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M289.179,303.288a.267.267,0,0,1-.258-.2c-.221-.871-5.4-21.408-3.871-27.62,1.363-5.549,10.725-11.118,13.188-12.5l-3.781-1.048a.266.266,0,0,1-.185-.327.262.262,0,0,1,.326-.185l4.41,1.223a.265.265,0,0,1,.053.49c-.119.064-12.015,6.442-13.5,12.474-1.494,6.083,3.816,27.15,3.87,27.362a.265.265,0,0,1-.192.323A.283.283,0,0,1,289.179,303.288Z",
    transform: "translate(-284.769 -261.397)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(16.79 145.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M254.608,350.341a.231.231,0,0,1-.064-.009L249.372,349a.255.255,0,1,1,.128-.495l5.171,1.332a.256.256,0,0,1-.064.5Z",
    transform: "translate(-249.181 -348.497)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(58.722 148.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M305.977,352.788h-7.7a.256.256,0,0,1,0-.512h7.7a.256.256,0,0,1,0,.512Z",
    transform: "translate(-298.019 -352.276)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(55.843 23.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M294.936,249.78s5.454,2.114,17.761,2.452,15.248,0,15.248,0l.926-41.427s-4.645-6.761-20.928-3.748S294.936,249.78,294.936,249.78Z",
    transform: "translate(-294.666 -206.284)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(56.112 24.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M294.98,249.907l8.3,1.217a156.114,156.114,0,0,1,.75-25.3c1.465-15.2,3.816-18.443,3.961-18.635-3.147,1.073-8.985,3.369-10.06,5.847C296.447,216.459,294.98,249.907,294.98,249.907Z",
    transform: "translate(-294.98 -207.185)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(16.294 11.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M271.863,201.859s-1.012-4.488-3.41-6.533-5.234-3.362-4.738-1.542a29.16,29.16,0,0,0,2.157,4.793l-4.35-1.158a37.627,37.627,0,0,0-4.9-1.867,2.134,2.134,0,0,0-2.71.966s-2.061-.549-2.957.056-.261,1.9-.261,1.9-2.957.057-1.844,2.322,6.965,6.074,9.8,7.391,9.229,2.176,9.229,2.176S273.623,211.616,271.863,201.859Z",
    transform: "translate(-248.602 -192.92)",
    fill: "#db786e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(23.377 17.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M257.122,203.752a.27.27,0,0,1-.128-.508l7.546-4.046a.27.27,0,0,1,.254.476l-7.545,4.046A.27.27,0,0,1,257.122,203.752Z",
    transform: "translate(-256.852 -199.165)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(33.206 17.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M273.427,206.3a.263.263,0,0,1-.068-.009c-2.447-.635-4.03-1.685-4.706-3.117a3.833,3.833,0,0,1-.064-3.066.27.27,0,0,1,.489.228,3.348,3.348,0,0,0,.067,2.615c.606,1.278,2.069,2.225,4.349,2.817a.27.27,0,0,1-.068.532Z",
    transform: "translate(-268.3 -199.956)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(29.896 20.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M264.445,212.056l10.805-8.645,4.831,5.512c1.871,2.134,3.579,3.552,5.839,4a7.675,7.675,0,0,0,4.5-.575l6.488-2.784-1.785,23.716.134,2.237s-12.785,3.136-20.82-5.558C266.109,220.943,264.445,212.056,264.445,212.056Z",
    transform: "translate(-264.445 -203.411)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(46.873 29.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M285.624,220.376a1.314,1.314,0,0,1-.555-.133,1.383,1.383,0,0,1-.807-.986c-.431-1.9,2.478-5.454,2.6-5.6a.26.26,0,0,1,.287-.084.265.265,0,0,1,.183.237c.034.552.282,5.428-1.135,6.393A1.011,1.011,0,0,1,285.624,220.376Zm1.208-5.819c-.919,1.234-2.315,3.427-2.052,4.583a.863.863,0,0,0,.513.622.558.558,0,0,0,.606,0C286.752,219.179,286.869,216.263,286.832,214.557Z",
    transform: "translate(-284.218 -213.554)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(69.333 19.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M310.806,203.2l-.243,2.708-.185,2.061a6.286,6.286,0,0,0,3.579,1.533c3.315.217,4.253-1.832,4.253-1.832l.41-5.988c-.028-.027-1.071.23-1.071.23Z",
    transform: "translate(-310.378 -201.677)",
    fill: "#db786e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(69.517 19.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M310.836,203.2l-.243,2.708a5.966,5.966,0,0,0,3.211-.13,9.489,9.489,0,0,0,4.846-4.1c-.028-.027-1.071.23-1.071.23Z",
    transform: "translate(-310.593 -201.677)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(66.315 4.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M308.91,187.1s-3.061,7.78-1.7,12.037,5.259,3.434,7.573,2.516a7.77,7.77,0,0,0,3.349-2.4,3.306,3.306,0,0,0,3.607-1.43c1.39-2.091.4-4.4-.87-4.886a3.443,3.443,0,0,0-2.724.469l1.083-2.268S313.908,180.013,308.91,187.1Z",
    transform: "translate(-306.863 -184.738)",
    fill: "#db786e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(68.667 13.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M310,198.2a.242.242,0,0,1-.228-.161,4.344,4.344,0,0,1,.549-3.4.243.243,0,1,1,.409.262,3.925,3.925,0,0,0-.5,2.975.245.245,0,0,1-.229.325Z",
    transform: "translate(-309.602 -194.522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(77.829 14.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M320.517,198.541a.241.241,0,0,1-.159-.059.243.243,0,0,1-.025-.343l1.982-2.294a.243.243,0,1,1,.367.318l-1.982,2.294A.242.242,0,0,1,320.517,198.541Z",
    transform: "translate(-320.274 -195.761)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(78.556 15.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M322.812,198.094c-.027,0-1.474-.156-1.474-.156a.242.242,0,0,1-.215-.267.247.247,0,0,1,.267-.215l1.448.155a.243.243,0,0,1-.025.484Z",
    transform: "translate(-321.121 -197.454)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(72.166 11.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M313.921,194.983a.245.245,0,0,1-.242-.263l.119-1.434a.243.243,0,0,1,.483.04l-.119,1.434A.242.242,0,0,1,313.921,194.983Z",
    transform: "translate(-313.678 -193.063)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(67.916 11.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M308.972,194.8a.247.247,0,0,1-.242-.267l.148-1.432a.247.247,0,0,1,.266-.216.241.241,0,0,1,.216.266l-.147,1.431A.243.243,0,0,1,308.972,194.8Z",
    transform: "translate(-308.729 -192.887)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(71.766 9.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M315.064,191.871a.241.241,0,0,1-.211-.123c-.377-.66-1.3-.432-1.337-.422a.243.243,0,0,1-.123-.47,1.713,1.713,0,0,1,1.881.651.243.243,0,0,1-.09.331A.237.237,0,0,1,315.064,191.871Z",
    transform: "translate(-313.212 -190.795)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(67.44 9.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M308.416,191.163a.243.243,0,0,1-.168-.418,1.946,1.946,0,0,1,1.29-.541,1.139,1.139,0,0,1,.835.493.243.243,0,0,1-.388.292.668.668,0,0,0-.486-.3,1.525,1.525,0,0,0-.913.407A.247.247,0,0,1,308.416,191.163Z",
    transform: "translate(-308.173 -190.201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(63.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M305.733,180.972a8.723,8.723,0,0,1,1.052-.247c.225-.661.862-1.2,2.3-1.329a6.568,6.568,0,0,1,2.87.392c.65-.548,1.785-.884,3.779-.245a6.228,6.228,0,0,1,2.967,2.105,3.15,3.15,0,0,1,2.708.991,3.337,3.337,0,0,1,.891,3.641,3.141,3.141,0,0,1,1.159,1.9c.561,2.521-2.332,4.489-2.332,4.489a4.068,4.068,0,0,0-3.455-.05.955.955,0,0,1-1.381-.32c-.613-.873.527-3.583.527-3.583a6.681,6.681,0,0,1-3.846-.078,5.874,5.874,0,0,1-2.313-2.844s-.98,2.293-4.259,1.447S302.319,182.021,305.733,180.972Z",
    transform: "translate(-303.53 -179.195)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(68.645 24.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M313.9,210.745a6.274,6.274,0,0,1-4.249-1.793.266.266,0,0,1,.385-.366,5.774,5.774,0,0,0,4.328,1.606,5.911,5.911,0,0,0,3.724-1.886.266.266,0,0,1,.411.337,6.351,6.351,0,0,1-4.087,2.078C314.237,210.738,314.067,210.745,313.9,210.745Z",
    transform: "translate(-309.578 -208.211)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(69.814 17.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M312.462,201.345a2.3,2.3,0,0,1-1.452-.642.243.243,0,0,1,.074-.394l2.47-1.091a.248.248,0,0,1,.23.018.243.243,0,0,1,.111.2c0,.064,0,1.568-1.026,1.852A1.515,1.515,0,0,1,312.462,201.345Zm-.81-.756a1.389,1.389,0,0,0,1.088.234c.415-.115.573-.627.634-.993Z",
    transform: "translate(-310.939 -199.198)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(0 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    d: "M0,0H184.227A4.169,4.169,0,0,1,188.4,4.169V184.4a4.169,4.169,0,0,1-4.169,4.169H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(0.305 7.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M181.065,55.931V224.824a3.386,3.386,0,0,1-3.388,3.388H.355V52.543H177.677A3.386,3.386,0,0,1,181.065,55.931Z",
    transform: "translate(-0.355 -52.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(0.003 7.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M161.7,52.543.305,216.452l-.049.049L0,195.994l.3-.3L143.218,52.543Z",
    transform: "translate(-0.004 -52.543)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(0.305 7.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M112.45,52.543.355,166.39V146.119L93.776,52.543Z",
    transform: "translate(-0.355 -52.543)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(4.656 5.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 3.529,
    height: 180.26,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(34.932)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 3.529,
    height: 180.26,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(69.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 3.529,
    height: 180.26,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(104.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 3.529,
    height: 180.26,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(139.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 3.529,
    height: 180.26,
    fill: "#eeecf1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 47.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(0 89.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 3.529,
    height: 182.704,
    transform: "translate(0 3.529) rotate(-90)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(0 45.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 3.529,
    height: 182.704,
    transform: "translate(0 3.529) rotate(-90)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 3.529,
    height: 182.704,
    transform: "translate(0 3.529) rotate(-90)",
    fill: "#eeecf1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(177.402 182.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M227.457,232.207s7.4-11.533,6.974-13.185c-.274-1.058-3.332,2.947-3.332,2.947s3.031-8.635,1.938-9.13-6.365,15.313-6.365,15.313,3.565-22.393,2.267-22.783-5.269,22.32-5.269,22.32-3.056-18.239-4.532-17.288,1.428,16.889,1.428,16.889-5.526-13.2-6.259-11.09c-.655,1.883,2.753,11.571,2.753,11.571s-10.724-16.648-10.429-13.942,9.738,18.852,9.738,18.852Z",
    transform: "translate(-206.625 -205.364)",
    fill: "#90a38d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(8.703 25.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M229.2,251.64h-9.884a1.019,1.019,0,0,1-1.037-.883l-1.512-14.4a1,1,0,0,1,1.037-1.074h12.908a1,1,0,0,1,1.037,1.074l-1.512,14.4A1.019,1.019,0,0,1,229.2,251.64Z",
    transform: "translate(-216.762 -235.284)",
    fill: "#bbafc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(6.516 25.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M226.652,251.64h-9.884a1.019,1.019,0,0,1-1.037-.883l-1.512-14.4a1,1,0,0,1,1.037-1.074h12.908a1,1,0,0,1,1.037,1.074l-1.512,14.4A1.019,1.019,0,0,1,226.652,251.64Z",
    transform: "translate(-214.214 -235.284)",
    fill: "#ddd7e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(66.62 160.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(10.159 96.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M91.036,355.977c-1.426-.611-2.008-2.5-1.322-4.3l22.7-59.378,9.373,4.016L95.079,353.93C94.263,355.69,92.477,356.594,91.036,355.977Z",
    transform: "translate(-89.426 -292.304)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(34.8 96.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M149.04,356.129c-1.432.6-3.195-.3-4.008-2.036l-26.9-57.594,9.4-3.947L150.378,351.8C151.075,353.609,150.484,355.522,149.04,356.129Z",
    transform: "translate(-118.127 -292.552)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(0 29.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M101.685,214.485s-27.612,9.353-23.715,43.426c3.58,31.3,32.429,41.642,53.911,34.277s14.45-28.967,14.45-28.967Z",
    transform: "translate(-77.594 -214.485)",
    fill: "#e2dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(22.621 84.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M137.712,282.893c0,2.1-7.56,3.8-16.885,3.8s-16.885-1.7-16.885-3.8,7.56-3.8,16.885-3.8S137.712,280.794,137.712,282.893Z",
    transform: "translate(-103.941 -279.092)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(27.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M124.059,181.482s-7.746-4.489-11.7,2.992-2.006,29.208-2.006,29.208h12.568l1.138-32.2Z",
    transform: "translate(-109.874 -180.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(73.971 21.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M169.759,205.023l1.117,5.4-7.125-.527v-2.675Z",
    transform: "translate(-163.75 -205.023)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(59.687 25.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M154.381,221.537l2.874-12.21,11.094.932s6.8,28.236-3.7,33.074c-9.7,4.469-17.535-4.668-17.535-4.668Z",
    transform: "translate(-147.113 -209.327)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(60.929 134.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M164,336.272l.862,12.871h-16.3V336.272Z",
    transform: "translate(-148.56 -336.272)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(96.584 100.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M202.141,296.952l8.817,9.416-12.726,10.4-8.145-9.966Z",
    transform: "translate(-190.088 -296.952)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(49.363 87.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M168.13,297.613v34.458H140.28l-5.192-47.552,22.185-2.483Z",
    transform: "translate(-135.088 -282.036)",
    fill: "#b75542"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(24.092 61.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M197.481,286.7s-22.658-26.906-36.347-31.154-53.233-3.921-53.233-3.921-7.186,20.914,4.142,26.107,33.195,4.248,36.9,6.136S175.3,307.944,175.3,307.944Z",
    transform: "translate(-105.654 -251.622)",
    fill: "#b75542"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(16.845 22.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M97.214,231.278s2.116-21.284,12.675-23.893a34.951,34.951,0,0,1,23.8,2.112c5.713,2.435,13.635,11.6,13.635,11.6l-4.553,20.259-5.865-1.1.1,7.741-31.1.829L101.958,232.6Z",
    transform: "translate(-97.214 -206.21)",
    fill: "#507849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(38.036 16.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M122.816,199.824l-.92,6.684s.941,2.087,4.807,2.943c2.88.638,3.994.12,3.994.12l.06-3.441.054-3.356-6.846-2.525Z",
    transform: "translate(-121.896 -199.824)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(40.104 17.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M124.306,200.319a2.207,2.207,0,0,0,.1.672c1.036,3.544,5.026,4.827,6.687,5.209l.054-3.356Z",
    transform: "translate(-124.305 -200.319)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(34.715 1.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M133.851,185.253s2.354,8.863.331,13.328-6.162,3.079-8.568,1.786a8.514,8.514,0,0,1-3.346-3.033,3.628,3.628,0,0,1-3.75-2.012c-1.25-2.454.118-4.841,1.563-5.214a3.776,3.776,0,0,1,2.909.854l-.894-2.607S129.3,176.9,133.851,185.253Z",
    transform: "translate(-118.028 -182.205)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(48.143 11.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M134.1,197.309a.278.278,0,0,1-.118-.027.268.268,0,0,1-.12-.356,4.288,4.288,0,0,0-.17-3.3.266.266,0,1,1,.477-.234,4.766,4.766,0,0,1,.169,3.774A.266.266,0,0,1,134.1,197.309Z",
    transform: "translate(-133.668 -193.239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(36.608 11.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M122.369,196.332a.266.266,0,0,1-.221-.117l-1.87-2.749a.265.265,0,1,1,.439-.3l1.871,2.75a.265.265,0,0,1-.07.368A.259.259,0,0,1,122.369,196.332Z",
    transform: "translate(-120.232 -193.051)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(36.196 12.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M121.614,195.607l-1.6-.014a.265.265,0,0,1,0-.531l1.6.014a.265.265,0,0,1,0,.531Z",
    transform: "translate(-119.752 -195.063)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(43.692 14.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M130.56,200.059a1.55,1.55,0,0,1-.924-.294,3.116,3.116,0,0,1-1.15-1.978.266.266,0,0,1,.385-.269l3.071,1.6a.266.266,0,0,1,.036.449A2.673,2.673,0,0,1,130.56,200.059Zm-1.4-1.789a2.323,2.323,0,0,0,.78,1.064,1.32,1.32,0,0,0,1.316.027Z",
    transform: "translate(-128.484 -197.489)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(44.084 7.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M129.205,189.773a.261.261,0,0,1-.157-.052.266.266,0,0,1-.057-.371c.719-.979,2.457-.592,2.531-.575a.266.266,0,0,1-.118.518c-.409-.094-1.559-.207-1.985.372A.262.262,0,0,1,129.205,189.773Z",
    transform: "translate(-128.94 -188.686)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(49.092 7.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M136.575,189.862a.265.265,0,0,1-.226-.125.92.92,0,0,0-1.207-.278.265.265,0,0,1-.207-.489,1.451,1.451,0,0,1,1.867.489.265.265,0,0,1-.089.364A.258.258,0,0,1,136.575,189.862Z",
    transform: "translate(-134.773 -188.821)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(49.273 91.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M167.279,301.461a.266.266,0,0,1-.2-.086c-.106-.116-10.692-11.56-14.055-12.314-3.427-.767-17.659-2.023-17.8-2.036a.265.265,0,1,1,.046-.528c.586.052,14.411,1.271,17.872,2.046,3.524.79,13.89,12,14.329,12.471a.266.266,0,0,1-.195.446Z",
    transform: "translate(-134.984 -286.496)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(67.111 86.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M156.025,288.315a.293.293,0,0,1-.081-.012.267.267,0,0,1-.185-.262c.033-1.019.26-6.134,1.521-6.788a.734.734,0,0,1,.783.068c1.818,1.2-1.44,6.3-1.817,6.874A.269.269,0,0,1,156.025,288.315Zm1.581-6.613a.169.169,0,0,0-.08.021c-.626.325-1.035,3.03-1.185,5.31,1.179-2.01,2.333-4.676,1.431-5.27A.316.316,0,0,0,157.606,281.7Z",
    transform: "translate(-155.76 -281.171)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(86.928 94.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M179.108,307.37a.266.266,0,0,1-.189-.453l16.36-16.414a.266.266,0,0,1,.376.375L179.3,307.291A.265.265,0,0,1,179.108,307.37Z",
    transform: "translate(-178.842 -290.424)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(54.28 130.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M160.832,332.631H141.081a.266.266,0,0,1,0-.531h19.751a.266.266,0,0,1,0,.531Z",
    transform: "translate(-140.816 -332.1)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(73.972 9.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M169.759,206.409a6.008,6.008,0,0,0,6.008-6.008v-9.7H163.751v9.7A6.008,6.008,0,0,0,169.759,206.409Z",
    transform: "translate(-163.751 -190.697)",
    fill: "#f2513b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(73.972 8.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M163.751,190.583c0,.381,2.69.69,6.008.69s6.008-.309,6.008-.69-2.69-.691-6.008-.691S163.751,190.2,163.751,190.583Z",
    transform: "translate(-163.751 -189.892)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(69.48 11.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M158.519,199.863c0-3.2,2.014-5.8,4.491-5.8s4.492,2.6,4.492,5.8-2.015,5.8-4.492,5.8S158.519,203.063,158.519,199.863Zm1.062,0c0,2.614,1.539,4.741,3.429,4.741s3.43-2.127,3.43-4.741-1.539-4.74-3.43-4.74S159.581,197.25,159.581,199.863Z",
    transform: "translate(-158.519 -194.061)",
    fill: "#f2513b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(69.13 15.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M158.811,207.692s-1.075-6.824-.56-8.139c.7-1.783,4.7-1.783,4.7-1.783v4.576a8.6,8.6,0,0,1,1.187,7.019C163.165,213.7,158.811,207.692,158.811,207.692Z",
    transform: "translate(-158.111 -197.77)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(76.728 12.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M168.493,197.759a3.973,3.973,0,0,1,1.473-1.175c1.937-.946,7.831-2.638,9.229-.837,1.339,1.725-1.905,2.765-1.905,2.765s2.783-.316,2.349,1.654a2.714,2.714,0,0,1-2.148,1.934s2.925-.052,1.527,2.17-7.62,3.44-9.78,3.043-.189-3.009-.189-3.009-2.273-.736-2.075-2.027c.209-1.368,2.121-1.607,2.121-1.607A1.878,1.878,0,0,1,168.493,197.759Z",
    transform: "translate(-166.961 -194.952)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(79.304 16.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M170.226,201.415a.266.266,0,0,1-.071-.522l7.487-2.095a.266.266,0,0,1,.143.512L170.3,201.4A.261.261,0,0,1,170.226,201.415Z",
    transform: "translate(-169.961 -198.788)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(79.453 19.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M170.4,205.509a.266.266,0,0,1-.068-.523l7.537-2.01a.265.265,0,1,1,.137.513L170.47,205.5A.271.271,0,0,1,170.4,205.509Z",
    transform: "translate(-170.136 -202.968)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(73.706 19.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M164.893,210.341a.262.262,0,0,1-.091-.016.266.266,0,0,1-.159-.34c1.177-3.251-1.133-6.743-1.156-6.779a.265.265,0,1,1,.44-.3c.1.151,2.486,3.749,1.215,7.257A.265.265,0,0,1,164.893,210.341Z",
    transform: "translate(-163.441 -202.792)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(37.066 22.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M129.911,211.022a19.593,19.593,0,0,1-4.108-.51c-3.948-.857-4.976-3.332-5.018-3.437a.266.266,0,0,1,.494-.2c.009.023.982,2.322,4.637,3.116,3.72.808,5.332.385,5.347.38a.265.265,0,0,1,.144.511A6,6,0,0,1,129.911,211.022Z",
    transform: "translate(-120.766 -206.711)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(45.05 8.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M130.33,193.2a.267.267,0,0,1-.265-.274l.051-1.577a.267.267,0,0,1,.076-.179l.766-.772a.266.266,0,1,1,.377.374l-.692.7-.047,1.472A.266.266,0,0,1,130.33,193.2Z",
    transform: "translate(-130.065 -190.319)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(49.698 9.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M135.744,193.625a.266.266,0,0,1-.265-.269l.02-1.579a.267.267,0,0,1,.064-.169l.672-.782a.265.265,0,0,1,.4.347l-.609.707-.019,1.482A.266.266,0,0,1,135.744,193.625Z",
    transform: "translate(-135.479 -190.734)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(54.669 32.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M142.991,243.184a.266.266,0,0,1-.265-.266v-7.154a.278.278,0,0,1,.014-.084,35.678,35.678,0,0,0,1.413-7.5c.377-4.348-2.812-9.493-2.844-9.546a.266.266,0,0,1,.451-.282c.135.216,3.315,5.346,2.923,9.873a36.6,36.6,0,0,1-1.425,7.579v7.112A.266.266,0,0,1,142.991,243.184Z",
    transform: "translate(-141.268 -218.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(37.013 45.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M121.1,239.983a.276.276,0,0,1-.265-.246c-.161-2.258-.31-6.1.5-6.5a.511.511,0,0,1,.593.131c1.263,1.155-.389,5.9-.581,6.437A.267.267,0,0,1,121.1,239.983Zm.418-6.26c-.259.234-.325,2.33-.234,4.542.515-1.815.883-3.959.288-4.5A.178.178,0,0,0,121.515,233.723Z",
    transform: "translate(-120.704 -233.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(36.676 0.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M123.453,191.792s2.925-2.909,5.5-3.795c1.713-.59,2.763-.955,2.763-.955l-.444-3.165,1.724,3.035,1.536-.265s.144-5.691-5.171-5.514-7.4,1.77-8.391,3.718-.563,5.1-.563,5.1A3.018,3.018,0,0,1,123.453,191.792Z",
    transform: "translate(-120.311 -181.129)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(36.599 1.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M120.5,187.947a.265.265,0,0,1-.264-.236c-.005-.049-.462-4.837,5.224-6.31a.264.264,0,0,1,.324.19.266.266,0,0,1-.19.325c-5.231,1.354-4.848,5.559-4.829,5.738a.265.265,0,0,1-.235.292Z",
    transform: "translate(-120.222 -181.392)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(101.218 98.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M228.9,294.451c-4.471.366-10.815,4.546-14.051,5.017s-8.4-.744-9.077.952-.483,6.556-4.167,9.1-5.932,3.1-6.114,4.7c-.127,1.116,3.976,7.007,6.8,10.577l-1.041,1.333,3,3.384,7.141-6.321c.5-.253-.723-3.959.4-4.236s4.353-1.008,6-1.431c0,0,17.623-14.67,20.579-18.091a.684.684,0,0,0-.118-.976C236.787,297.281,232.536,294.154,228.9,294.451Z",
    transform: "translate(-195.486 -294.431)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(54.915 140.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M183.685,355.724c-3.455-2.862-10.915-4.3-13.559-6.224s-5.492-6.4-7.162-5.658-4.925,4.356-9.337,3.6-6.409-1.927-7.657-.909c-.871.711-2.048,7.792-2.521,12.319l-1.676.227-.218,4.515,9.525.464c.537.172,2.247-3.338,3.245-2.751s3.82,2.319,5.292,3.164c0,0,22.859,1.809,27.363,1.425a.685.685,0,0,0,.6-.78C187.356,363.26,186.5,358.053,183.685,355.724Z",
    transform: "translate(-141.555 -343.761)",
    fill: "#f7c537"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(93.403 231.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M109.942,352.905a1.153,1.153,0,0,1-.94-1.819L171.125,263.4a1.153,1.153,0,1,1,1.881,1.333L110.883,352.42A1.151,1.151,0,0,1,109.942,352.905Z",
    transform: "translate(-108.79 -262.913)",
    fill: "#e0dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(217.662 231.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M316.8,352.905a1.153,1.153,0,0,1-.942-.486L253.73,264.732a1.153,1.153,0,1,1,1.881-1.333l62.124,87.687a1.153,1.153,0,0,1-.94,1.819Z",
    transform: "translate(-253.518 -262.913)",
    fill: "#e0dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(101.055 224.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M289.809,263.909H122.594a4.892,4.892,0,0,1,0-9.784H289.809a4.892,4.892,0,0,1,0,9.784Z",
    transform: "translate(-117.702 -254.125)",
    fill: "#bdb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(84.964 208.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(31.945 9.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M139.362,246.986a73.9,73.9,0,0,1,7.449,1.563c2.8.833,7.158,1.8,9,1.314s2.031.289,1.548,1.363-2.613,1.643-2.613,1.643,2.225,8.908,1.355,9.637-3.386-2.083-3.386-2.083a2.092,2.092,0,0,1-1.161.729,3.8,3.8,0,0,1-1.644-.312,1.734,1.734,0,0,1-1.435,1.041,2.558,2.558,0,0,1-1.952-.416s-.677,1.491-1.451,1.163-4.256-1.371-4.063-2.413,3.1-.834,3.1-.834l.386-1.77s-3,2.292-5.8.729-2.508-5.471-2.508-5.471Z",
    transform: "translate(-136.167 -246.986)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(47.624 14.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M155.294,261.6a.259.259,0,0,1-.169-.062.264.264,0,0,1-.034-.373c2.055-2.469-.6-7.277-.628-7.326a.265.265,0,0,1,.463-.26c.118.21,2.862,5.176.573,7.926A.266.266,0,0,1,155.294,261.6Z",
    transform: "translate(-154.429 -253.445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M99.835,236.177s-2.134,9.28.264,14.129c3.421,6.913,32.062,3.235,32.062,3.235l1.938-8.083-16.132-5,.053-.324S111.663,238.464,99.835,236.177Z",
    transform: "translate(-98.96 -236.177)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(45.418 18.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M152.125,262.648a.266.266,0,0,1-.208-.431c1.238-1.554.31-3.943.3-3.967a.266.266,0,0,1,.494-.2c.044.11,1.048,2.7-.379,4.494A.265.265,0,0,1,152.125,262.648Z",
    transform: "translate(-151.86 -257.885)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(42.032 19.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M148.181,263.472a.266.266,0,0,1-.166-.473c1.321-1.058,1.142-3.388,1.14-3.411a.265.265,0,0,1,.241-.287.261.261,0,0,1,.288.241c.009.107.207,2.634-1.337,3.871A.265.265,0,0,1,148.181,263.472Z",
    transform: "translate(-147.916 -259.299)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(214.191 209.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(8.704 0.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M259.612,243.787a29.578,29.578,0,0,1,25.087-5.305c14.7,3.647,13.674,14.046,13.674,14.046l-37.546-.7Z",
    transform: "translate(-259.612 -237.609)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(34.845 13.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M293.206,252.916s-5.848,1.658-1.6,2.322,11.642-1.357,11.642-1.357l-5.141-1.738Z",
    transform: "translate(-290.06 -252.142)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(0 3.289)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 8.703,
    cy: 6.228,
    rx: 8.703,
    ry: 6.228,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(1.162 12.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M255.669,251.736s-6.845.644-4.255,2.442c1.351.938,8.308-.01,8.308-.01s6.362.323,9.824-.381-1.112-1.47-6.251-2.05A25.086,25.086,0,0,0,255.669,251.736Z",
    transform: "translate(-250.828 -251.478)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M250,244.195s2.809-7.323,3.638-7.539,2.322,4.177,2.322,4.177Z",
    transform: "translate(-250 -236.648)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(10.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M267.544,244.195s-2.81-7.323-3.639-7.539-2.321,4.177-2.321,4.177Z",
    transform: "translate(-261.585 -236.648)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(3.432 7.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M254.692,246.5a1.576,1.576,0,0,1-1.167-.5.243.243,0,0,1,.378-.306c.028.034.64.738,1.833-.05a.243.243,0,0,1,.268.406A2.382,2.382,0,0,1,254.692,246.5Z",
    transform: "translate(-253.472 -245.604)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    transform: "translate(10.394 7.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M263,246.5a2.381,2.381,0,0,1-1.311-.451.243.243,0,1,1,.267-.406c1.2.789,1.808.08,1.833.05a.243.243,0,0,1,.378.306A1.576,1.576,0,0,1,263,246.5Z",
    transform: "translate(-261.581 -245.605)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(7.47 10.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M258.175,248.435s1.549-.042,1.549,0c0,.217-.532.779-.769.779C258.593,249.214,258.175,248.435,258.175,248.435Z",
    transform: "translate(-258.175 -248.416)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(11.472 1.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M264.742,241.442a.243.243,0,0,1-.243-.231,4.136,4.136,0,0,0-.491-2.055,4.545,4.545,0,0,0-.695,1.615.242.242,0,0,1-.468-.127c.143-.529.533-1.776,1.046-1.946a.435.435,0,0,1,.415.075c.558.434.663,2.088.678,2.415a.241.241,0,0,1-.231.253Z",
    transform: "translate(-262.837 -238.675)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(3.187 1.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M253.43,241.635a.247.247,0,0,1-.243-.255c.015-.327.121-1.982.678-2.415a.43.43,0,0,1,.415-.074c.513.171.9,1.417,1.047,1.945a.243.243,0,0,1-.469.128,3.783,3.783,0,0,0-.731-1.613,4.615,4.615,0,0,0-.454,2.052A.244.244,0,0,1,253.43,241.635Z",
    transform: "translate(-253.187 -238.867)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(37.055 3.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M295.486,241.275s10.989,3.034,8.695,24.97c-1.964,18.789-11.01,15.8-7.956,7.737,2.786-7.355,4.076-24.977-1.332-29.951S295.486,241.275,295.486,241.275Z",
    transform: "translate(-292.634 -240.782)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(7.227 10.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M259.684,250.409a.241.241,0,0,1-.181-.082l-.616-.689-.6.483a.243.243,0,1,1-.3-.378l.779-.628a.242.242,0,0,1,.334.027l.769.861a.243.243,0,0,1-.181.405Z",
    transform: "translate(-257.892 -249.062)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(248.571 185.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811",
    transform: "translate(0 27.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M309.122,243.282a31.091,31.091,0,0,0-4.565-1.828l-.042-.009c-1.111-.243-6.419-.547-6.854-.256a1.38,1.38,0,0,0,.081,2.295l1.175.748a22.772,22.772,0,0,0-5.332,2.273c-3.342,1.832-2.664,3.356-2.664,3.356s-2.115,1.476-1.151,2.37,4.489-.17,4.489-.17-4.425,1.873-2.529,2.809,5.977.471,5.977.471,8.971,1.211,11.8-2S309.122,243.282,309.122,243.282Z",
    transform: "translate(-289.519 -241.07)",
    fill: "#db786e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(9.428 29.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M300.761,244.755a.262.262,0,0,1-.035-.521l1.768-.247a.262.262,0,0,1,.072.519l-1.768.247Z",
    transform: "translate(-300.5 -243.984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(1.338 33.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M291.338,250.86a.261.261,0,0,1-.082-.509l6.84-2.261a.261.261,0,0,1,.165.5l-6.841,2.261A.245.245,0,0,1,291.338,250.86Z",
    transform: "translate(-291.077 -248.076)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(4.02 36.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M294.462,254a.262.262,0,0,1-.083-.51l4.287-1.432a.262.262,0,0,1,.167.5l-4.288,1.433A.28.28,0,0,1,294.462,254Z",
    transform: "translate(-294.2 -252.044)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(17.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M328.522,209.173s16.363,7.174,16.363,29.761c0,18.272-34.4,13-34.4,13l-1.1-15.568,13.83-5.018Z",
    transform: "translate(-309.384 -209.173)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    transform: "translate(27.211 19.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M321.478,236.263a.266.266,0,0,1-.139-.492c1.212-.747,7.335-4.434,8.769-3.561a.766.766,0,0,1,.349.77c-.191,2.6-8.064,3.221-8.961,3.282Zm7.992-3.676c-1.234,0-4.441,1.626-6.859,3.04,2.718-.3,7.2-1.121,7.316-2.686.016-.209-.063-.258-.1-.277A.7.7,0,0,0,329.471,232.587Z",
    transform: "translate(-321.213 -232.077)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    transform: "translate(330.233 77.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(69.808 87.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(5.762 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M813.663,188.427H807.9V177.313a2.881,2.881,0,1,1,5.763,0Z",
    transform: "translate(-807.9 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M806.951,188.427h-5.762V177.313a2.881,2.881,0,1,1,5.762,0Z",
    transform: "translate(-801.189 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(17.3 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M827.1,188.427h-5.763V177.313a2.881,2.881,0,1,1,5.763,0Z",
    transform: "translate(-821.339 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(1.377 0.616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(7.329 0.616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(18.867 0.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M805.338,173.125h-2.669a.616.616,0,1,1,0-1.231h2.669a.616.616,0,0,1,0,1.231Z",
    transform: "translate(-802.053 -171.894)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(6.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M812.178,173.125h-2.669a.616.616,0,0,1,0-1.231h2.669a.616.616,0,0,1,0,1.231Z",
    transform: "translate(-808.893 -171.894)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(18.231 0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M825.708,173.415h-2.669a.616.616,0,1,1,0-1.231h2.669a.616.616,0,1,1,0,1.231Z",
    transform: "translate(-822.423 -172.184)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0 47.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 35.919,
    height: 52.23,
    rx: 5.895,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(143.888 41.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    d: "M4.535,0H26.87a4.535,4.535,0,0,1,4.535,4.535v8.113a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.535A4.535,4.535,0,0,1,4.535,0Z",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(117.053 41.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    d: "M3.761,0H17.845a3.761,3.761,0,0,1,3.761,3.761v8.886a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.761A3.761,3.761,0,0,1,3.761,0Z",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(60.277 54.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M916.012,138.384H792.493a2.405,2.405,0,0,1,0-4.811H916.012Z",
    transform: "translate(-790.088 -133.573)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(49.583 78.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M915.684,166.964H780.038a2.405,2.405,0,1,1,0-4.811H915.684Z",
    transform: "translate(-777.632 -162.153)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(39.162 103.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M914.821,195.543H767.9a2.405,2.405,0,1,1,0-4.811h146.92Z",
    transform: "translate(-765.495 -190.732)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(14.931 28.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 7.428,
    height: 126.859,
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(184.138 28.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 7.428,
    height: 126.859,
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(9.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 188.051,
    height: 34.511,
    rx: 8.116,
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(66.089 58.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(1.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M809.792,143.361A5.7,5.7,0,1,1,804,137.748,5.7,5.7,0,0,1,809.792,143.361Z",
    transform: "translate(-798.387 -137.747)",
    fill: "#90a38d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(1.812 7.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M809.315,159.83l-8.189.027a.847.847,0,0,1-.862-.729L798.972,147.2a.832.832,0,0,1,.857-.893l10.694-.034a.832.832,0,0,1,.862.887L810.172,159.1A.846.846,0,0,1,809.315,159.83Z",
    transform: "translate(-798.968 -146.275)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 7.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M807.2,159.836l-8.189.027a.847.847,0,0,1-.862-.729l-1.291-11.926a.832.832,0,0,1,.856-.893l10.7-.034a.832.832,0,0,1,.862.887L808.06,159.1A.844.844,0,0,1,807.2,159.836Z",
    transform: "translate(-796.857 -146.282)",
    fill: "#eeecf1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(155.916 62.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(5.763 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M913.956,159.7h-5.763V148.591a2.881,2.881,0,0,1,5.763,0Z",
    transform: "translate(-908.193 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M907.244,159.7h-5.763V148.591a2.881,2.881,0,1,1,5.763,0Z",
    transform: "translate(-901.481 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(17.3 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M927.394,159.7h-5.763V148.591a2.881,2.881,0,0,1,5.763,0Z",
    transform: "translate(-921.631 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(1.378 0.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(7.329 0.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(18.867 0.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M905.63,144.4h-2.669a.615.615,0,1,1,0-1.23h2.669a.615.615,0,1,1,0,1.23Z",
    transform: "translate(-902.345 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(6.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M912.47,144.4H909.8a.615.615,0,1,1,0-1.23h2.669a.615.615,0,1,1,0,1.23Z",
    transform: "translate(-909.185 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(18.232 0.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M926,144.693h-2.669a.616.616,0,1,1,0-1.231H926a.616.616,0,0,1,0,1.231Z",
    transform: "translate(-922.716 -143.462)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(133.215 62.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(5.763 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M887.516,159.7h-5.763V148.591a2.881,2.881,0,1,1,5.763,0Z",
    transform: "translate(-881.753 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M880.8,159.7h-5.763V148.591a2.881,2.881,0,1,1,5.763,0Z",
    transform: "translate(-875.041 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(17.3 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M900.954,159.7h-5.763V148.591a2.881,2.881,0,0,1,5.763,0Z",
    transform: "translate(-895.191 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(1.378 0.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(7.329 0.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(18.867 0.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M879.19,144.4h-2.669a.615.615,0,1,1,0-1.23h2.669a.615.615,0,1,1,0,1.23Z",
    transform: "translate(-875.905 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(6.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M886.03,144.4h-2.669a.615.615,0,1,1,0-1.23h2.669a.615.615,0,1,1,0,1.23Z",
    transform: "translate(-882.745 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(18.232 0.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M899.56,144.693h-2.668a.616.616,0,1,1,0-1.231h2.668a.616.616,0,1,1,0,1.231Z",
    transform: "translate(-896.276 -143.462)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(169.531 87.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 1.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M923.1,188.427h-5.763V177.313a2.881,2.881,0,0,1,5.763,0Z",
    transform: "translate(-917.339 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(1.567 0.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 2.629,
    height: 2.629,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(0.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M921.708,173.415h-2.669a.616.616,0,1,1,0-1.231h2.669a.616.616,0,1,1,0,1.231Z",
    transform: "translate(-918.423 -172.184)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(143.526 82.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(0 4.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M903.65,187.837h-16.6l1.717-16.6h13.165Z",
    transform: "translate(-887.051 -171.238)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(0.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M888.828,170.506l-1.15-2.061a1.6,1.6,0,0,1,1.4-2.384h13.012a1.6,1.6,0,0,1,1.292,2.551l-1.389,1.894Z",
    transform: "translate(-887.472 -166.061)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(4.21 8.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 8.18,
    height: 8.18,
    rx: 1.39,
    fill: "#c7bfce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(83.004 58.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 4.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M833.158,159.524h-16.6l1.717-16.6h13.165Z",
    transform: "translate(-816.559 -142.925)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M818.336,142.193l-1.15-2.061a1.6,1.6,0,0,1,1.4-2.383H831.6a1.6,1.6,0,0,1,1.292,2.551l-1.389,1.894Z",
    transform: "translate(-816.98 -137.748)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(4.21 8.888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 8.18,
    height: 8.18,
    rx: 1.39,
    fill: "#c7bfce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(88.706 6.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(0 3.557)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 14.387,
    cy: 8.878,
    rx: 14.387,
    ry: 8.878,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(1.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M827.443,78.076a.845.845,0,0,1,1.438-.277l2.44,2.814,3.4,3.921-5.1.984-5.1.984,1.7-4.905Z",
    transform: "translate(-824.53 -77.507)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(17.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M850.785,78.076a.845.845,0,0,0-1.438-.277l-2.44,2.814-3.4,3.921,5.1.984,5.1.984L852,81.6Z",
    transform: "translate(-843.507 -77.507)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(389.067 147.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(9.231 41.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M809.922,213.977l-5.311-.622s-4.5-3.187-5.362-6.171S804,200.355,804,200.355l3.591,1.265,3.389,9.409Z",
    transform: "translate(-799.16 -200.355)",
    fill: "#f98575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(0 32.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 11.784,
    height: 27.123,
    rx: 2.159,
    transform: "translate(17.061 26.554) rotate(168.249)",
    fill: "#bdb2c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(2.632 31.582)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 11.784,
    height: 27.123,
    rx: 2.159,
    transform: "matrix(-0.979, 0.204, -0.204, -0.979, 17.061, 26.555)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(7.534 44.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M797.474,206.168a.292.292,0,0,1-.053-.579L804,204.363a.292.292,0,0,1,.107.574l-6.582,1.226A.3.3,0,0,1,797.474,206.168Z",
    transform: "translate(-797.182 -204.359)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(6.792 40.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M796.61,201.545a.292.292,0,0,1-.053-.579l6.582-1.227a.292.292,0,0,1,.107.574l-6.582,1.226A.3.3,0,0,1,796.61,201.545Z",
    transform: "translate(-796.318 -199.735)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(5.925 37.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M795.6,197.171a.292.292,0,0,1-.053-.579l6.583-1.226a.287.287,0,0,1,.34.234.292.292,0,0,1-.233.341l-6.583,1.226A.292.292,0,0,1,795.6,197.171Z",
    transform: "translate(-795.308 -195.361)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(11.988 39.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M812.221,204.906s-2.5-6.6-3.928-7.054-6,.121-5.922,1.83,4.124,2.091,4.124,2.091a13.216,13.216,0,0,0,.149,4.845,3.555,3.555,0,0,0,2.678,2.441Z",
    transform: "translate(-802.37 -197.705)",
    fill: "#f98575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(15.488 42.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M808.823,209.557a.288.288,0,0,1-.156-.045c-3.341-2.1-1.937-6.993-1.875-7.2a.289.289,0,0,1,.362-.2.293.293,0,0,1,.2.363c-.014.046-1.339,4.672,1.627,6.54a.292.292,0,0,1-.155.539Z",
    transform: "translate(-806.447 -202.102)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(47.218 74.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M850.932,261.667s-.515,1.628-1.375,4.375h27.988c1.96-20.358-2.355-27.351-2.355-27.351H843.4Z",
    transform: "translate(-843.404 -238.692)",
    fill: "#bc574a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(44.997 76.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M841.092,266.334h24.844l4.274-25.58-27.171.551A74.363,74.363,0,0,0,841.092,266.334Z",
    transform: "translate(-840.816 -240.754)",
    fill: "#507849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(56.504 30.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M857.621,190.45a9.142,9.142,0,0,1-3.224-.55.292.292,0,0,1,.228-.537,9.057,9.057,0,0,0,8.754-1.568.292.292,0,0,1,.367.454A9.593,9.593,0,0,1,857.621,190.45Z",
    transform: "translate(-854.219 -187.729)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(13.79 29.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M848.752,185.927s-5.057,1.059-11.121,8.541c-5.08,6.268-8.572,13.375-9.655,13.992s-13.105-6.7-14.3-6.42-9.207,13.8-9.207,13.8,18.746,13.689,27.145,12.047,14.567-11.209,14.567-11.209Z",
    transform: "translate(-804.469 -185.927)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(46.122 29.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M855.64,186.486s-7.042,1.066-10.554,9.219-2.674,19.947-2.674,19.947-1.077,16.789.956,17.622,10.974.586,18.553.739a117.848,117.848,0,0,0,13.965-.728s-.951-37.327-3.761-43.348S855.64,186.486,855.64,186.486Z",
    transform: "translate(-842.127 -185.941)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(36.906 51.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M833.032,218.823a1.471,1.471,0,0,1-.452-.079c-2.115-.7-.793-5.928-.635-6.522a.267.267,0,0,1,.238-.2.289.289,0,0,1,.264.162c.372.877,2.177,5.315,1.193,6.383A.791.791,0,0,1,833.032,218.823Zm-.762-5.652c-.355,1.739-.7,4.683.477,5.068.366.12.468.009.5-.028C833.735,217.682,833.037,215.167,832.27,213.171Z",
    transform: "translate(-831.393 -212.025)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(39.214 63.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M849.5,226.2s-8.967-.537-12.18,1.782-3.54,9.986-3.055,10.645,1.6.349,1.6.349.12,1.408.825,1.838,1.753-.446,1.753-.446,1.242,1.348,2.474.787a2.577,2.577,0,0,0,1.318-2.8,4.044,4.044,0,0,1-.064-1.192l.7.159s1.255,1.38,4.32.944,5.755-5.383,5.755-5.383Z",
    transform: "translate(-834.081 -226.142)",
    fill: "#f98575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(53.016 30.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M850.157,218.665l2.083,13.591s21.686,3.237,30.578-10.551-5.124-33.178-12.369-34.224c-4.427-.64-4.538,24.034-4.538,24.034Z",
    transform: "translate(-850.157 -187.469)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(64.139 53.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M863.378,217.563a.266.266,0,0,1-.09-.516l7.457-2.682a.265.265,0,0,1,.179.5l-7.457,2.682A.248.248,0,0,1,863.378,217.563Z",
    transform: "translate(-863.113 -214.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(66.158 49.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M865.729,216a.268.268,0,0,1-.163-.056.265.265,0,0,1-.081-.313c.24-.567,2.4-5.544,3.95-5.857a.806.806,0,0,1,.743.224.973.973,0,0,1,.287.78c-.109,1.747-4.118,4.823-4.575,5.169A.271.271,0,0,1,865.729,216Zm3.879-5.712a.36.36,0,0,0-.067.007c-.817.165-2.195,2.579-3.123,4.553,1.406-1.164,3.452-3.071,3.517-4.1a.437.437,0,0,0-.128-.365A.272.272,0,0,0,869.608,210.284Z",
    transform: "translate(-865.464 -209.753)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(56.796 23.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M863.757,178.96l-.148,6.653s-1.242,1.886-5.141,2.116c-2.905.171-3.909-.507-3.909-.507l.479-3.361.471-3.277,7.063-1.39Z",
    transform: "translate(-854.559 -178.96)",
    fill: "#f98575"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(57.275 23.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M862.651,179.233a2.176,2.176,0,0,1-.208.638c-1.563,3.29-5.649,3.917-7.326,4.029l.471-3.277Z",
    transform: "translate(-855.117 -179.233)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(53.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M853.89,162.756s-3.677,8.265-2.4,12.93,5.521,3.961,8.065,3.078a8.4,8.4,0,0,0,3.733-2.431,3.58,3.58,0,0,0,3.967-1.375c1.6-2.194.641-4.733-.709-5.323a3.724,3.724,0,0,0-2.966.378l1.278-2.4S859.628,155.335,853.89,162.756Z",
    transform: "translate(-851.219 -153.208)",
    fill: "#f98575"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(2.449 2.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M684.822,158.143s2.04-5.1,9.081-3.226,7.191,6.857,7.191,6.857,2.664.042,1.844,5.093-6.815,9.84-9.035,6.214-2.145-11.95-2.145-11.95Z",
    transform: "translate(-684.822 -154.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(1.901 4.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M695.288,167.6s-3.615-1.853-4.922-4.457a10.974,10.974,0,0,1-1.357-3.908,3.415,3.415,0,0,1-1.847,2.109,10.064,10.064,0,0,1-2.138.447l-.841,2.427.548-5.787a32.679,32.679,0,0,1,4.049-1.909c.478,0,6.51,1.082,6.859,1.445s2.249,5.048,2.249,5.048l.131,2.116Z",
    transform: "translate(-684.184 -156.52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(14.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M700.459,158.84s4.39-9.965,9.314-6.565-1.524,12.487-7.386,11.051S700.459,158.84,700.459,158.84Z",
    transform: "translate(-699.167 -151.567)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(56.492 16.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M854.624,174.792a.293.293,0,0,1-.279-.206,4.733,4.733,0,0,1,.758-3.676.292.292,0,0,1,.477.336,4.221,4.221,0,0,0-.677,3.167.291.291,0,0,1-.192.365A.277.277,0,0,1,854.624,174.792Z",
    transform: "translate(-854.205 -170.788)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(66.346 17.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M865.975,175.672a.292.292,0,0,1-.212-.492l2.251-2.386a.292.292,0,1,1,.424.4l-2.251,2.386A.289.289,0,0,1,865.975,175.672Z",
    transform: "translate(-865.683 -172.703)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(67.172 19.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M868.494,175.282a.251.251,0,0,1-.044,0l-1.557-.236a.292.292,0,0,1-.245-.332.289.289,0,0,1,.332-.246l1.557.236a.292.292,0,0,1-.043.581Z",
    transform: "translate(-866.645 -174.461)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(57.862 20.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M857.471,178.041a2.513,2.513,0,0,1-1.587-.731.293.293,0,0,1,.117-.482l3.24-1.078a.294.294,0,0,1,.3.068.29.29,0,0,1,.077.292,3.109,3.109,0,0,1-1.444,1.764A1.542,1.542,0,0,1,857.471,178.041Zm-.765-.832a1.246,1.246,0,0,0,1.2.143,2.235,2.235,0,0,0,.871-.833Z",
    transform: "translate(-855.801 -175.736)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(60.1 12.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M860.414,168.192a.293.293,0,0,1-.26-.159c-.367-.716-1.382-.507-1.392-.5a.292.292,0,0,1-.124-.571,1.889,1.889,0,0,1,2.036.809.291.291,0,0,1-.127.392A.285.285,0,0,1,860.414,168.192Z",
    transform: "translate(-858.408 -166.916)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(55.43 12.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M855.167,167.118a.29.29,0,0,1-.24-.127.7.7,0,0,0-.488-.336,1.507,1.507,0,0,0-.987.39.292.292,0,0,1-.386-.438,2.116,2.116,0,0,1,1.442-.531,1.255,1.255,0,0,1,.9.585.291.291,0,0,1-.075.405A.3.3,0,0,1,855.167,167.118Z",
    transform: "translate(-852.968 -166.066)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(56.53 29.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M858.236,189.167a12.049,12.049,0,0,1-3.816-.644.266.266,0,1,1,.19-.5c.056.022,5.671,2.1,8.753-1.532a.266.266,0,0,1,.406.343A6.984,6.984,0,0,1,858.236,189.167Z",
    transform: "translate(-854.249 -186.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(60.1 14.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M858.975,171.377a.3.3,0,0,1-.289-.329l.184-1.44-.416-.658a.292.292,0,0,1,.493-.312l.472.746a.287.287,0,0,1,.043.192l-.2,1.545A.291.291,0,0,1,858.975,171.377Z",
    transform: "translate(-858.408 -168.503)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(55.429 13.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M853.62,170.944a.3.3,0,0,1-.289-.334l.21-1.418-.513-.673a.292.292,0,1,1,.464-.354l.588.771a.289.289,0,0,1,.056.219l-.228,1.54A.291.291,0,0,1,853.62,170.944Z",
    transform: "translate(-852.968 -168.049)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(40.698 69.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M836.1,240.293a.292.292,0,0,1-.292-.285c0-.182-.084-4.465,1.123-6.444a.292.292,0,0,1,.5.3c-1.118,1.833-1.038,6.084-1.037,6.127a.291.291,0,0,1-.285.3Z",
    transform: "translate(-835.81 -233.424)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(43.227 71.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M839.1,241.945a.292.292,0,0,1-.29-.261c-.019-.18-.456-4.45,1.513-6.345a.292.292,0,0,1,.4.422c-1.764,1.7-1.341,5.819-1.337,5.861a.291.291,0,0,1-.259.321A.182.182,0,0,1,839.1,241.945Z",
    transform: "translate(-838.755 -235.259)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(8.305 49.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M798.372,210.972a.292.292,0,0,1-.054-.579l6.583-1.227a.292.292,0,1,1,.107.574l-6.583,1.227A.287.287,0,0,1,798.372,210.972Z",
    transform: "translate(-798.08 -209.161)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(9.216 53.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M799.434,215.6a.291.291,0,0,1-.053-.578l6.582-1.226a.292.292,0,0,1,.107.574l-6.582,1.226A.294.294,0,0,1,799.434,215.6Z",
    transform: "translate(-799.142 -213.791)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(13.073 43.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 5.701,
    height: 19.487,
    rx: 1.147,
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 9.744, 0)",
    fill: "#618958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(52.167 58.268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 5.773,
    height: 18.743,
    rx: 1.13,
    transform: "matrix(0.988, -0.154, 0.154, 0.988, 0, 0.887)",
    fill: "#618958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(61.84 70.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M860.7,239.129a.265.265,0,0,1-.013-.531c.114-.006,11.454-.59,17.462-4.37a.266.266,0,0,1,.283.45c-6.127,3.854-17.6,4.445-17.72,4.45Z",
    transform: "translate(-860.435 -234.188)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(45.694 40.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M843.237,222.169a.266.266,0,0,1-.266-.266v-3.109s-.256-1.91-1.175-7.348c-.942-5.56,2.406-11.719,2.55-11.979a.265.265,0,1,1,.464.257c-.034.061-3.4,6.258-2.492,11.634.926,5.473,1.18,7.385,1.181,7.4l0,3.143A.266.266,0,0,1,843.237,222.169Z",
    transform: "translate(-841.629 -199.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(49.692 90.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M846.485,257.553l7.653,2.456c-.217.939-1.489,4.356-3.14,8.621h.628a81.989,81.989,0,0,0,3.131-8.819.3.3,0,0,0-.2-.283L846.665,257a.29.29,0,0,0-.366.19A.287.287,0,0,0,846.485,257.553Z",
    transform: "translate(-846.285 -256.984)",
    fill: "#ad4d40"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(63.55 39.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(0 1.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M870.854,201.5c0,1.436-1.886,2.6-4.214,2.6s-4.214-1.164-4.214-2.6,1.887-2.6,4.214-2.6S870.854,200.061,870.854,201.5Z",
    transform: "translate(-862.426 -198.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M863.669,197.85a.248.248,0,0,1,.422-.082l.714.824,1,1.149-1.493.288-1.492.288.5-1.436Z",
    transform: "translate(-862.816 -197.683)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(5.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M870.506,197.85a.248.248,0,0,0-.422-.082l-.714.824-1,1.149,1.492.288,1.493.288-.5-1.436Z",
    transform: "translate(-868.374 -197.683)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(371.156 198.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 47.507,
    height: 23.549,
    rx: 6.341,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(16.746 17.585)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 12.433,
    height: 23.014,
    fill: "#eeecf1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(5.986 2.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M785.279,215.853l-10.5-.074a.266.266,0,0,1,0-.531l10.5.074a.266.266,0,0,1,0,.531Z",
    transform: "translate(-774.518 -215.248)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(483.108 194.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(0 16.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M915.526,228.357H899.048a1.108,1.108,0,1,1,0-2.215h16.478Z",
    transform: "translate(-897.94 -226.142)",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(10.304 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M944.061,208.492v34.317h-34.12V208.492a2.052,2.052,0,0,1,2.052-2.052h30.016A2.052,2.052,0,0,1,944.061,208.492Z",
    transform: "translate(-909.941 -206.44)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(10.304 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M944.061,208.492v6.345h-34.12v-6.345a2.052,2.052,0,0,1,2.052-2.052h30.016A2.052,2.052,0,0,1,944.061,208.492Z",
    transform: "translate(-909.941 -206.44)",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(40.945 12.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M945.9,235.379a.266.266,0,0,1-.265-.266V221.179a.266.266,0,1,1,.531,0v13.934A.266.266,0,0,1,945.9,235.379Z",
    transform: "translate(-945.63 -220.913)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(329.778 230.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(70.558 0.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    d: "M0,0H133.764a2.583,2.583,0,0,1,2.583,2.583V88.261a2.583,2.583,0,0,1-2.583,2.583H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#c4bcc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(0 0.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    d: "M19.262,0H190.3a2.809,2.809,0,0,1,2.809,2.809V88.034a2.809,2.809,0,0,1-2.809,2.809H2.78A2.78,2.78,0,0,1,0,88.064v-68.8A19.262,19.262,0,0,1,19.262,0Z",
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(95.868 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M831.44,339.621a.429.429,0,0,1-.428-.428v-90.46a.428.428,0,0,1,.857,0v90.46A.429.429,0,0,1,831.44,339.621Z",
    transform: "translate(-831.012 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(128.503 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M869.451,339.621a.429.429,0,0,1-.428-.428v-90.46a.428.428,0,0,1,.857,0v90.46A.429.429,0,0,1,869.451,339.621Z",
    transform: "translate(-869.023 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(161.223 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M907.562,340a.428.428,0,0,1-.428-.428V248.732a.428.428,0,0,1,.857,0v90.843A.429.429,0,0,1,907.562,340Z",
    transform: "translate(-907.133 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(30.373 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M755.156,340a.429.429,0,0,1-.428-.428V248.732a.428.428,0,0,1,.857,0v90.843A.428.428,0,0,1,755.156,340Z",
    transform: "translate(-754.728 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(63.093 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M793.266,340a.428.428,0,0,1-.428-.428V248.732a.428.428,0,0,1,.857,0v90.843A.429.429,0,0,1,793.266,340Z",
    transform: "translate(-792.838 -248.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(202.453 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 18.098,
    cy: 18.098,
    r: 18.098,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(3.902 3.902)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 14.196,
    cy: 14.196,
    r: 14.196,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(15.259 11.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M400.933,49.129a.584.584,0,0,1-.211-.04.571.571,0,0,1-.345-.4l-1.714-7.06a.572.572,0,0,1,1.113-.27l1.522,6.272,9.5-6.213a.573.573,0,0,1,.627.959l-10.182,6.656A.572.572,0,0,1,400.933,49.129Z",
    transform: "translate(-398.647 -40.924)",
    fill: "#a89fb3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain1);
export default __webpack_public_path__ + "static/media/retain1.4ed58234cbe5f296586a1d1145603194.svg";
export { ForwardRef as ReactComponent };